import Rpc from '@/config/apiServer/chain33rpc'
import { checkGroup } from './common'
import { ref, reactive, Ref } from 'vue'
import { ElMessage } from 'element-plus'
import { TxType } from '@/types/types'

interface MixinsType {
  loading: Ref<boolean>,
  block: {
    infos: Record<string, unknown>,
    hashes: string[],
    txs: TxType[],
  },
  pages: {
    currentPage: number,
    pageSize: number,
    total: number
  },
  getBlock: (height: number) => Promise<void>,
  getTxs: () => Promise<void>,
  pageChange: (page: number) => void,
  sizeChange: (size: number) => void
}

export default (): MixinsType => {
  const loading = ref(false)
  const block = reactive({
    infos: {},
    hashes: [],
    txs: []
  })
  const pages = reactive({
    currentPage: 1,
    pageSize: 10,
    total: 0
  })

  async function getBlock(height: number | string): Promise<void> {
    const res = await Rpc.getBlockHash(Number(height))
    if (res.error != null) ElMessage.warning(res.error)
    const data = await Rpc.getBlockOverview(res.result.hash)
    if (data.error != null) ElMessage.warning(res.error)
    block.infos = data.result.head
    block.hashes = data.result.txHashes.reverse()
    pages.total = data.result.txCount
    getTxs()
  }

  async function getTxs(): Promise<void> {
    loading.value = true
    const start = pages.pageSize * (pages.currentPage - 1)
    const end = pages.pageSize * pages.currentPage - 1 < pages.total ? pages.pageSize * pages.currentPage : pages.total
    const res = await Rpc.getTxByHashes(block.hashes.slice(start, end))
    block.txs = checkGroup(res.result.txs) as any
    loading.value = false
  }

  function pageChange(page: number): void {
    pages.currentPage = page;
    getTxs()
  }
  function sizeChange(size: number): void {
    pages.pageSize = size;
    pages.currentPage = 1
    getTxs()
  }

  return { getBlock, getTxs, block, loading, pages, pageChange, sizeChange }
}